import { styled } from 'styled-components'
import WizrFlexLayout from '../WizrFlexLayout'
import WizrInput from '../WizrInput'
import WizrFlexSpacing from '../WizrFlexSpacing'
import WizrButton from '../WizrButton'
import { Form } from 'antd'
import { useGetIntegrationList } from '../../redux/selectors/content'
import WizrDropDown from '../WizrDropDown'
import WizrText from '../WizrText'
import { useEffect, useState, useRef } from 'react'
import { dispatchIntegrationList} from '../../redux/actions/content'

const StyledContainer = styled(WizrFlexLayout)`
  gap: 8px;
  width: 100%;
  position: relative;
`

const StyledLabel = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
`

const StyledForm = styled(Form)`
  width: 100%;
`
const StyledDropDown = styled(WizrDropDown)`
  height: 52px;
  .ant-select-selector {
    padding-top: 10px !important;
    border-radius:16px;
    height: 52px !important;
    background-color: #f2f4f9 !important;
    .ant-select-selection-placeholder {
      margin-top: 10px;
    }
  }
`


const InputContainer = styled(WizrFlexLayout)`
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  background-color: #fff;
  width: 100%;
`

interface IUploadConfluenceForm {
  onFormSubmission: any
  onCancel: any
}

const UploadConfluenceForm = ({ onFormSubmission, onCancel }: IUploadConfluenceForm): JSX.Element => {
  const [form] = Form.useForm()
  useEffect(() => {
    dispatchIntegrationList()
    // dispatchGetIntegrationToolsForTenants()
  }, [])
  const dropDownConverterIntegrations = (value: any[]): { label: string; value: string }[] => {
    if (!value?.length) return [];

    // Filter for only Confluence integrations
    const confluenceIntegrations = value.filter(item =>
      item?.integration_key?.toLowerCase() === 'confluence'
    );

    return confluenceIntegrations.map((item: any) => ({
      label: item?.display_name,
      value: item.id,
    }));
  }
  
  // const integrationsForConfluence = useGetIntegrationList()
  const integrationsForTools = useGetIntegrationList()

  const options = dropDownConverterIntegrations(integrationsForTools);

  const [data, setdata] = useState({
    integration_display_name: '',
    integration_id: '',
    confluence_space_url: ''
  })

  // Validation state
  const [showUrlValidation, setShowUrlValidation] = useState(false)
  const [showIntegrationValidation, setShowIntegrationValidation] = useState(false)

  // Refs for error scrolling
  const urlRef = useRef<HTMLDivElement>(null)
  const integrationRef = useRef<HTMLDivElement>(null)

  // Validation function
  const validateAllFields = () => {
    const isBlank = (text?: string) => !text || text.trim() === ''
    let isValid = true
    let firstErrorRef: React.RefObject<HTMLDivElement> | null = null

    // Reset validation states
    setShowUrlValidation(false)
    setShowIntegrationValidation(false)

    // Validate confluence_space_url
    if (isBlank(data?.confluence_space_url)) {
      setShowUrlValidation(true)
      if (!firstErrorRef) firstErrorRef = urlRef
      isValid = false
    }

    // Validate integration_id
    if (isBlank(data?.integration_id)) {
      setShowIntegrationValidation(true)
      if (!firstErrorRef) firstErrorRef = integrationRef
      isValid = false
    }

    // Scroll to first error
    if (!isValid && firstErrorRef?.current) {
      setTimeout(() => {
        firstErrorRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 100)
    }

    return isValid
  }

  const handleSubmit = () => {
    if (!validateAllFields()) {
      return
    }

    onFormSubmission({
      confluence_space_url: data.confluence_space_url,
      integration_id: data.integration_id,
      integration_display_name: data.integration_display_name
    })
  }

  return (
    <StyledContainer background='#FFF' justifyContent='space-evenly'>
      <div style={{ width: '100%', position: 'relative' }}>
        <WizrFlexLayout
          flexDirection='column'
          justifyContent='flex-start'
          background='#fff'
          alignItems='flex-start'
          style={{ width: '100%', gap: '16px' }}
        >
        <StyledForm
          name='confluence'
          form={form}
          layout='vertical'
          onFinish={handleSubmit}
          onFinishFailed={() => null}
          autoComplete='off'
          style={{ width: '100%' }}
        >
          <Form.Item name='confluence_space_url'>
            <InputContainer ref={urlRef}>
              <WizrText type='body2'>Confluence URL</WizrText>
              <WizrInput
                style={{ width: '100%' }}
                value={data?.confluence_space_url}
                placeholder='Paste your Confluence space URL Or Page URL'
                onChange={(value: string) => {
                  setdata({ ...data, confluence_space_url: value });
                  form.setFieldsValue({ confluence_space_url: value });
                  if (value && showUrlValidation) {
                    setShowUrlValidation(false)
                  }
                }}
                background='#F2F4F9'
                showError={showUrlValidation}
                errorMessage={showUrlValidation ? "Please Enter Confluence URL" : undefined}
              />
            </InputContainer>
          </Form.Item>

          <Form.Item name='integration_id'>
            <InputContainer ref={integrationRef}>
              <WizrText type='body2'>Select Integrations</WizrText>
              <StyledDropDown
                value={data?.integration_id}
                options={options}
                onChange={(value: any, option: any) => {
                  setdata({ ...data, integration_id: value });
                  form.setFieldsValue({ integration_id: value });
                  if (value && showIntegrationValidation) {
                    setShowIntegrationValidation(false)
                  }
                }}
                showError={showIntegrationValidation}
                errorMessage={showIntegrationValidation ? "Please Select an Integration" : undefined}
              />
            </InputContainer>
          </Form.Item>

          <WizrFlexSpacing
            justifyContent='flex-end'
            flexDirection='row'
            size='large'
            background='#FFF'
          >
            <WizrButton
              type='default'
              text='Cancel'
              onClick={onCancel}
              style={{ borderRadius: '20px' }}
            />
            <WizrButton
              text='Add Confluence Space'
              onClick={handleSubmit}
              style={{ borderRadius: '20px' }}
            />
          </WizrFlexSpacing>
        </StyledForm>
        </WizrFlexLayout>
      </div>
    </StyledContainer>
  )
}

export default UploadConfluenceForm